module.exports = __webpack_public_path__ + "bc42b76ad6f3c2ca12fc2fc01a914d92.svg";